import React from 'react';
import PharmacyListTable from './components/PharmacyListTable/PharmacyListTable';

const PharmacyList = () => {
  return <PharmacyListTable />;
};

export default PharmacyList;
